import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./index.css";

class ResultItem extends Component {
  static propTypes = {
    item: PropTypes.shape({
      searchTerm: PropTypes.string.isRequired,
      numberOfResults: PropTypes.number
    }),
    setSearchTerm: PropTypes.func.isRequired,
    term: PropTypes.string.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    buttonRef: PropTypes.func.isRequired
  };

  static bold = (match, word) => {
    return word.replace(
      new RegExp(match, "i"),
      match => `<span class="${styles.bold}">${match}</span>`
    );
  };

  static boldTermInText = (text, term) => {
    const terms = term.split(/ /g);
    const wordArray = text.split(/ /g);

    return wordArray
      .map(word => {
        const firstMatch = terms.find(t => new RegExp(t, "i").test(word));
        return firstMatch ? ResultItem.bold(firstMatch, word) : word;
      })
      .join(" ");
  };

  static formatText = phrase => {
    return phrase
      .replace(/asos/i, "ASOS")
      .split(/ /g)
      .map(word => `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`)
      .join(" ");
  };

  handleSubmit = () => {
    const { setSearchTerm, item: { searchTerm } } = this.props;

    setSearchTerm(searchTerm);
  };

  renderResultLabel(label) {
    const { term } = this.props;

    const text = ResultItem.formatText(label);
    return ResultItem.boldTermInText(text, term);
  }

  renderResultCount(resultCount) {
    return (
      <span className={styles.count}>
        {resultCount.toLocaleString().replace(/\.00$/, "")}
      </span>
    );
  }

  render() {
    const { onKeyDown, item: { numberOfResults, searchTerm } } = this.props;

    return (
      <li>
        <button
          role="option"
          ref={this.props.buttonRef}
          onKeyDown={onKeyDown}
          className={styles.button}
          onClick={this.handleSubmit}
        >
          <span
            className={styles.label}
            dangerouslySetInnerHTML={{
              __html: this.renderResultLabel(searchTerm)
            }}
          />
          {numberOfResults && this.renderResultCount(numberOfResults)}
        </button>
      </li>
    );
  }
}

export default ResultItem;



// WEBPACK FOOTER //
// ./template/components/SearchDropdown/ResultItem/index.js